import {IDNameDescriptionItem} from './Site'
import {ManulApiModel } from '../models/ManulApiModel'

const getSelectData = function(data:IDNameDescriptionItem[]){


}

export {getSelectData};

const GetBanks = async () :Promise<any[]>=> {
    let banksDetails = localStorage.getItem('BanksDetails');

    if (banksDetails === null) {
        try {
            const banksAll = await new ManulApiModel().GetGovBanks();
            localStorage.setItem('BanksDetails', JSON.stringify(banksAll));
            banksDetails = JSON.stringify(banksAll);
        } catch (error) {
            console.error("Failed to fetch banks:", error);
            return [];
            // throw error;
        }
    }

    return banksDetails ? JSON.parse(banksDetails) : [];
};
export {GetBanks};

